/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RevenueReport } from '../models/RevenueReport';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ControllingRevenueReportService {
    /**
     * returns the revenue report
     * @param year year
     * @param tenantIdsArray tenant ids
     * @returns RevenueReport successful
     * @throws ApiError
     */
    public static getRevenueReport(
        year: number,
        tenantIdsArray?: Array<string>,
    ): CancelablePromise<RevenueReport> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/controlling/revenue_report',
            query: {
                'year': year,
                'tenant_ids[]': tenantIdsArray,
            },
        });
    }
}
